export default __webpack_public_path__ + "static/media/box.bc3ae88c.svg";